import { render } from "./AuxiliaryAccountingDetail.vue?vue&type=template&id=4481b316&scoped=true"
import script from "./AuxiliaryAccountingDetail.vue?vue&type=script&lang=js"
export * from "./AuxiliaryAccountingDetail.vue?vue&type=script&lang=js"

import "./AuxiliaryAccountingDetail.vue?vue&type=style&index=0&id=4481b316&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4481b316"]])

export default __exports__